<template>
  <v-container>
    <v-row>
      <v-col>
        <v-tabs
          v-model="tab"
          align-tabs="start"
          class="smaller-tabs"
          color="#0F6DAC"
          density="compact"
          slider-color="primary">
          <v-tab
            class="text-none text-caption text-capitalize"
            prepend-icon="mdi-pencil"
            value="basicData"
            variant="text"
            data-cy="basicData-tab">
            {{ t(`entities.machine.tabs.machineHourlyRate`) }}
          </v-tab>
        </v-tabs>

        <v-window v-model="tab">
          <v-window-item
            key="basicData"
            value="basicData">
            <v-container fluid>
              <BasicData :node-id="nodeId" />
            </v-container>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

import BasicData from "./FormParts/BasicData.vue";

const { t } = useTranslation();
const tab = ref("basicData");

defineProps({
  nodeId: {
    type: String,
    required: true
  }
});
</script>

<style>
.smaller-tabs span.v-btn__prepend {
  margin-inline: 0 !important;
}

.smaller-tabs .v-tab {
  padding: 0 0.3rem !important;
}
</style>
